import { Link, useNavigate } from "react-router-dom"
import useMainStore from "../../store/mainState";
import { useTranslation } from 'react-i18next';
import { ReactComponent as LinkIcon } from "../../assets/icons/link.svg"
import { ReactComponent as BitcoinIcon } from "../../assets/icons/bitcoin.svg"
import { ReactComponent as TelIcon } from "../../assets/icons/tel.svg"
import { ReactComponent as XIcon } from "../../assets/icons/x.svg"
import { ReactComponent as LocalTelIcon } from "../../assets/icons/localTel.svg"
import { ReactComponent as GitIcon } from "../../assets/icons/git.svg"
import { ReactComponent as FbIcon } from "../../assets/icons/fb.svg"
import { ReactComponent as DiscIcon } from "../../assets/icons/disc.svg"
import { ReactComponent as InstaIcon } from "../../assets/icons/insta.svg"



const Footer = () => {
    const navigate = useNavigate();
    const { isCollapsed, user, activeItem, setActiveItem, activeSubItem, setActiveSubItem } = useMainStore();
    const { t } = useTranslation();

    const navigateToCasino = (subCategory: string, category: string) => {
        setActiveItem(category);
        setActiveSubItem(subCategory);
        navigate(category);
    }
    return (
        <footer >
            <div className="border-t border-b border-white/[0.06] my-[40px] p-[20px] flex justify-between flex-wrap gap-y-[30px]">
                <div className="flex flex-col gap-[20px]">
                    <p className="text-white text-[18px] font-bold mb-[16px] tracking-tight">
                        {t('footer.casino')}
                    </p>
                    <button onClick={() => navigateToCasino("All", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.casinoHome')}
                    </button>
                    <button onClick={() => navigateToCasino("SLOT", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.slots')}
                    </button>
                    <button onClick={() => navigateToCasino("FISH", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.fish')}
                    </button>
                    <button onClick={() => navigateToCasino("Blackjack", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.blackjack')}
                    </button>
                    <button onClick={() => navigateToCasino("Baccarat", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.baccarat')}
                    </button>
                    <button onClick={() => navigateToCasino("Roulette", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.roulette')}
                    </button>
                    <button onClick={() => navigateToCasino("POKER", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.poker')}
                    </button>
                    <button onClick={() => navigateToCasino("LIVE_CASINO", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.liveCasino')}
                    </button>
                    <button onClick={() => navigateToCasino("MINI_GAME", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.miniGame')}
                    </button>
                    <button onClick={() => navigateToCasino("PLINKO", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.plinko')}
                    </button>
                    <button onClick={() => navigateToCasino("OTHER", "casino")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.other')}
                    </button>
                </div>
                <div className="flex flex-col gap-[20px]">
                    <p className="text-white text-[18px] font-bold mb-[16px] tracking-tight">
                        {t('footer.sports')}
                    </p>
                    <button onClick={() => navigateToCasino("", "sport")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.sportsHome')}
                    </button>
                </div>
                <div className="flex flex-col gap-[20px]">
                    <p className="text-white text-[18px] font-bold mb-[16px] tracking-tight">
                        {t('footer.promo')}
                    </p>
                    <button onClick={() => navigateToCasino("", "raffle")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.raffleDraws')}
                    </button>
                    <button onClick={() => navigateToCasino("vip", "vip")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.vipClub')}
                    </button>
                    <button onClick={() => navigateToCasino("bonus", "bonus")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.promotions')}
                    </button>
                    {/* <button onClick={() => navigateToCasino("basketball", "sports")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        Refer a friend
                    </button> */}
                </div>
                <div className="flex flex-col gap-[20px]">
                    <p className="text-white text-[18px] font-bold mb-[16px] tracking-tight">
                        {t('footer.supportLegal')}
                    </p>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.licenses')}
                    </button>
                    {/* <button onClick={() => navigateToCasino("soccer", "sports")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        Help center
                    </button>
                    <button onClick={() => navigateToCasino("tennis", "sports")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        Important Announcement
                    </button> */}
                    <button onClick={() => navigateToCasino("#", "# ")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.gambleAware')}
                    </button>
                    {/* <button onClick={() => navigateToCasino("basketball", "sports")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        Fairness
                    </button> */}
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.faq')}
                    </button>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.privacyPolicy')}
                    </button>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.termsOfService')}
                    </button>
                    {/* <button onClick={() => navigateToCasino("basketball", "sports")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        Law Enforcement
                    </button> */}
                    <button onClick={() => navigateToCasino("faq", "responsible-gambling")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.responsibleGambling')}
                    </button>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.app')}
                    </button>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('footer.liveSupport')}
                    </button>
                    <button onClick={() => navigate('/support')} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200">
                        {t('support.title')}
                    </button>
                </div>
                <div className="flex flex-col gap-[20px]">
                    <p className="text-white text-[18px] font-bold mb-[16px] tracking-tight">
                        {t('footer.aboutUs')}
                    </p>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px]">
                        {t('footer.news')} <LinkIcon />
                    </button>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px]">
                        {t('footer.workWithUs')} <LinkIcon />
                    </button>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px]">
                        {t('footer.businessContacts')}
                    </button>
                    <button onClick={() => navigateToCasino("#", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px]">
                        {t('footer.helpDesk')} <LinkIcon />
                    </button>

                </div>
                <div className=" max-w-[300px]">
                    <p className="text-white text-[18px] font-bold mb-[16px] tracking-tight">
                        {t('footer.joinCommunity')}
                    </p>
                    <div className="flex flex-row flex-wrap gap-[20px]">
                        <button onClick={() => navigateToCasino("soccer", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <TelIcon />
                        </button>
                        {/* <button onClick={() => navigateToCasino("soccer", "sports")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <GitIcon />
                        </button> */}
                        <button onClick={() => navigateToCasino("tennis", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <XIcon />
                        </button>
                        <button onClick={() => navigateToCasino("basketball", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <FbIcon />
                        </button>
                        {/* <button onClick={() => navigateToCasino("basketball", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <DiscIcon />
                        </button>
                        <button onClick={() => navigateToCasino("basketball", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <BitcoinIcon />
                        </button> */}
                        <button onClick={() => navigateToCasino("basketball", "#")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <InstaIcon />
                        </button>
                    </div>
                    {/* <p className="text-white text-[20px] font-bold my-[20px]">
                        Join Our Local Community
                    </p>
                    <div className="flex flex-row flex-wrap gap-[20px]">
                        <button onClick={() => navigateToCasino("soccer", "sports")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <TelIcon />
                        </button>
                        <button onClick={() => navigateToCasino("soccer", "sports")} className="text-white/40 text-[14px] font-medium text-left hover:text-white/70 transition-colors duration-200 flex items-center gap-[10px] w-[55px] h-[55px] rounded-[10px] bg-[#0086D333] justify-center items-center">
                            <LocalTelIcon />
                        </button>
                    </div> */}
                </div>

            </div>
            {/* Trust badges */}
            <div className="flex flex-col md:flex-row gap-[10px] justify-center my-[20px] px-[20px]">
                <div className="flex-1 flex items-center gap-[12px] bg-white/[0.04] border border-white/[0.08] rounded-[12px] px-[16px] py-[14px]">
                    <div className="w-[36px] h-[36px] rounded-full border-2 border-white/20 flex items-center justify-center flex-shrink-0">
                        <span className="text-white/70 text-[11px] font-bold leading-none">18+</span>
                    </div>
                    <span className="text-white/60 text-[14px] font-semibold">{t('footer.responsibleGambling')}</span>
                </div>
                <div className="flex-1 flex items-center gap-[12px] bg-white/[0.04] border border-white/[0.08] rounded-[12px] px-[16px] py-[14px]">
                    <div className="w-[36px] h-[36px] rounded-full bg-[#0086D3]/15 flex items-center justify-center flex-shrink-0">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4DBDFF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                            <path d="M9 12l2 2 4-4" />
                        </svg>
                    </div>
                    <span className="text-white/60 text-[14px] font-semibold">{t('footer.provablyFair')}</span>
                </div>
                <div className="flex-1 flex items-center gap-[12px] bg-white/[0.04] border border-white/[0.08] rounded-[12px] px-[16px] py-[14px]">
                    <div className="w-[36px] h-[36px] rounded-full bg-emerald-500/15 flex items-center justify-center flex-shrink-0">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                            <path d="M9 12l2 2 4-4" />
                        </svg>
                    </div>
                    <span className="text-white/60 text-[14px] font-semibold">{t('footer.licensed')}</span>
                </div>
            </div>

            <p className="text-white/20 text-[13px] font-medium mb-[10px] text-center tracking-wide">
                {t('footer.copyright')}
            </p>
        </footer>
    )
}

export default Footer